import { useTranslation } from 'react-i18next';

import { PersonReadModel, usePutPersonsByIdMutation } from '@client/api';
import { Skeleton } from '@client/toolkit';

import { PersonFormData, UserForm } from '../../components';

interface UserEditModalProps {
  id: string;
  user?: PersonReadModel;
  open: boolean;
  onClose: () => void;
  onAfterSubmit: () => void;
}

export function UserEditModal({ id, user, open, onClose, onAfterSubmit }: UserEditModalProps) {
  const { t, ready } = useTranslation('users');

  const [putPerson] = usePutPersonsByIdMutation();

  const handleSubmit = async (data: PersonFormData) => {
    await putPerson({ id, body: { ...data } }).unwrap();
    onAfterSubmit();
  };

  return (
    <UserForm
      open={open}
      title={ready ? t('userEdit.title') : <Skeleton variant="text" />}
      onSubmit={handleSubmit}
      onClose={onClose}
      person={user}
      edit
    />
  );
}
